import * as React from 'react';
import * as style from './FAQ.css';
import { ArticleHeading1, ArticleHeading2, ArticleHeading3, ArticleHeading5, useDeviceType } from '@cian/ui-kit';
import { QUESTIONS_ANSWERS } from '../../constants/faq';

export const FAQ: React.FC = () => {
  const for3Question = (
    <>
      Публикация рейтинга на сторонних ресурсах возможна только с указанием ссылки на источник{' '}
      <a className={style['link']} href="https://www.cian.ru/" target="_blank" rel="noreferrer">
        cian.ru
      </a>
    </>
  );

  const isPhone = useDeviceType() === 'phone';

  const TitleQuestion = isPhone ? ArticleHeading3 : ArticleHeading1;

  const TextAnswer = isPhone ? ArticleHeading5 : ArticleHeading2;

  return (
    <div className={style['container']} id="faq">
      <div className={style['list']}>
        {QUESTIONS_ANSWERS.map(({ id, queston, answer }) => (
          <div className={style['item']} key={id}>
            <TitleQuestion>
              {id}. {queston}
            </TitleQuestion>
            <div className={style['textblock']}>
              <TextAnswer fontWeight="400">{id === 3 ? for3Question : answer}</TextAnswer>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
